function normalizeCoordinate(coordinate) {
  if (!Array.isArray(coordinate) || coordinate.length < 2) {
    return null;
  }

  const longitude = Number(coordinate[0]);
  const latitude = Number(coordinate[1]);

  if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) {
    return null;
  }

  return [longitude, latitude];
}

export default function getPinnedTooltipCoordinate(info) {
  const positionCoordinate = normalizeCoordinate(info?.object?.position);

  if (positionCoordinate) {
    return positionCoordinate;
  }

  const geometry = info?.object?.geometry;

  if (geometry?.type === 'Point') {
    return normalizeCoordinate(geometry.coordinates);
  }

  if (geometry?.type === 'MultiPoint') {
    return normalizeCoordinate(geometry.coordinates?.[0]);
  }

  return normalizeCoordinate(info?.coordinate);
}